/**
 * Created by mykurisu on 2017/10/11.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import { browserHistory } from 'react-router'
import {WKCurrencyItem, WKInfiniteScroll} from '../../components/wk'
import NewIntroItem from './NewIntroItem'
import questionImg from '../../images/new_question.png'


class IntroArea extends React.Component {
    constructor() {
        super();
        this.state = {
            channelList: null,
            list: null,
            has_more: true,
            next_offset: 0,
            loading: false,
            isApiError: false,
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        }, () => {
            let times = 0;
            axios.get('/api/recommend/lectures')
                .then((res) => {
                    if (res.data.code === 0){
                        this.setState({
                            list: res.data.data.lectures,
                            has_more: res.data.data.has_more,
                            next_offset: res.data.data.next_offset,
                            loading: false
                        })
                    }else {
                        this.setState({ loading: false })
                        times = times + 1;
                        if (times === 2){
                            this.props.handleHistoryPageShow(1)
                        }
                    }
                });

            axios.get('/api/recommend/channels', {
                params: {
                    limit: 10
                }
            })
                .then((res) => {
                    if (res.data.code === 0){
                        this.setState({channelList: res.data.data.channels})
                    }else {
                        this.setState({ loading: false })
                        times = times + 1;
                        if (times === 2){
                            this.props.handleHistoryPageShow(1)
                        }
                    }
                })
        })
    }

    handleLoadMore() {
        this.setState({
            loading: true
        }, () => {
            axios.get('/api/recommend/lectures', {
                params: {
                    offset: this.state.next_offset
                }
            })
                .then((res) => {
                    if (res.data.code === 0){
                        let newlist = this.state.list.concat(res.data.data.lectures);
                        this.setState({
                            list: newlist,
                            has_more: res.data.data.has_more,
                            next_offset: res.data.data.next_offset,
                            loading: false,
                        })
                    } else {
                        this.setState({ loading: false, isApiError: true })
                    }
                })
        });
    }

    onClickTip () {
        // location.assign('/specials/feedback')
        // window.location = 'http://cn.mikecrm.com/0mpV0MR'
        location.assign('https://jinshuju.net/f/cGlP5j')
    }

    render() {
        return (
            <div className="introarea">
                {((this.state.list && this.state.list.length !== 0) || (this.state.channelList && this.state.channelList.length !== 0)) &&
                <div className="introarea_title">
                    <span>微课推荐</span>
                    <span className="tip" onClick={e => this.onClickTip()}>
                        推荐不准
                        <span className='icon'><img src={questionImg} /></span>
                    </span>
                </div>
                }
                <div className="new__introitem-container">
                    {this.state.channelList && this.state.channelList.map((item) =>
                        <NewIntroItem
                            key={item.id}
                            type="channel"
                            content={item}
                            attr="wk_intro"
                            st="lzwk_inside"
                        />)
                    }
                    {this.state.list && this.state.list.map((item) =>
                        <NewIntroItem
                            key={item.id}
                            type="lecture"
                            content={item}
                            attr="wk_intro"
                            st="lzwk_inside"
                        />)
                    }
                    <WKInfiniteScroll
                        onTouchBottom={() => this.handleLoadMore()} // 到达底部执行的方法
                        isStop={this.state.loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                        distance={300} // 距离底部多少px触发
                        isKill={!this.state.has_more || (this.props.tabIndex !== 0) || this.state.isApiError} // 不再监听滚动，一般是传has_more
                        isShowLoading={true}
                    />
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    account: state.account,
}))(IntroArea)



// WEBPACK FOOTER //
// ./src/pages/mywkPage/IntroArea.js